import { render, staticRenderFns } from "./UnsubscribeList.vue?vue&type=template&id=3d92827c"
import script from "./UnsubscribeList.vue?vue&type=script&lang=js"
export * from "./UnsubscribeList.vue?vue&type=script&lang=js"
import style0 from "./UnsubscribeList.vue?vue&type=style&index=0&id=3d92827c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports